<template lang="html">
  <div class="list-card-category">
    <Carousel
      class="prueba-carousel"
      :settings="settings"
      :breakpoints="breakpoints"
    >
      <Slide class="expandX" v-for="(item, idx) in data" :key="idx">
        <CardCategoryInfo
          :imageURL="baseUrlStorage+item.imageURL"
          :title="item.title"
          :description="item.description"
          :id="item.id"
          :router="route"
        />
      </Slide>

      <template #addons>
        <Navigation class="z-index" />
      </template>
    </Carousel>
  </div>
</template>
<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";

import CardCategoryInfo from "./CardCategoryInfo.vue";

export default {
  inject: ['baseUrlStorage'],
  components: {
    Carousel,
    Slide,
    Navigation,
    CardCategoryInfo,
  },
  props: {
    route: String,
    data:Array,
  },

  data: () => ({
    categories: [
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Justicia para niña(o)s con discapacidad",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
      },
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Justicia para niña(o)s con discapacidad",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
      },
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Justicia para niña(o)s con discapacidad",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
      },
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Justicia para niña(o)s con discapacidad",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
      },
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Justicia para niña(o)s con discapacidad",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
      },
      {
        imageURL: "https://i.ibb.co/JH4gKwY/Card-Category-Info1.png",
        title: "Justicia para niña(o)s con discapacidad",
        description:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do",
      },
    ],
    settings: {
      itemsToShow: 1,
      snapAlign: "start",
    },
    // breakpoints are mobile first
    // any settings not specified will fallback to the carousel settings
    breakpoints: {
      // 700px and up
      0: {
        itemsToShow: 1,
      },
      700: {
        itemsToShow: 2,
      },
      1000: {
        itemsToShow: 3,
        snapAlign: "start",
      },
      // 1024 and up
      1400: {
        itemsToShow: 4,
        snapAlign: "start",
      },
    },
  }),
};
</script>
<style lang="css">
.list-card-category .carousel__track {
  gap: 0;
}

.list-card-category .carousel__prev,
.list-card-category .carousel__next {
  height: 162px;
  width: 80px;
  background: linear-gradient(to left, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.2));
  margin-right: 40px;
  border-radius: 0;
  z-index: 10;
}
.list-card-category .carousel__prev {
  margin-right: 0;
  margin-left: 40px;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.2));
  z-index: 10;
}
.list-card-category .carousel__prev--in-active,
.list-card-category .carousel__next--in-active {
  display: none;
}
.list-card-category .carousel__viewport {
  border-radius: 10px;
}
.prueba-carousel {
  height: 210px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.expandX {
  transition: all 0.5s;
}
.expandX:hover {
  width: 380px !important;
}
a {
  text-decoration: none;
}
.z-index {
  z-index: auto !important;
}
</style>
